module.exports = __webpack_public_path__ + "img/ir.8bb45d37.svg";